// extracted by mini-css-extract-plugin
export var inputAddorment = "input__addorment_aRFQqnqRIevi8hOoh_9e";
export var inputAddormentItem = "input__addorment-item_jJFKaRf43Af9HkVGYIaN";
export var inputAddormentItemClickable = "input__addorment-item_clickable_wA2UV7sd64gbQTJhfiMa";